<template>
  <v-container fluid>
    <v-row justify="center" no-gutters>
      <v-col cols="12" md="11"><v-row justify="start" class="mb-3 mt-n6 ml-5"> </v-row>
        <v-container v-if="data_order != null" class="" fluid>
          <v-row>
            <span class="mb-4 ml-4 mt-0" style="font-size: 24px; color: #616161">Orden de compra #{{
              filLeft(data_order[0]?.order_id.toString(), 12, "0") }}
              -
              <v-chip outlined color="primary">{{
                data_order[0]?.last_status_name
              }}</v-chip>
            </span>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-show="others_orders?.length > 0" v-bind="attrs" v-on="on" outlined dense small color="primary"
                  @click="next_order()">Orden siguiente</v-btn>
              </template>
              <span>Pendientes: {{ others_orders?.length }}</span>
            </v-tooltip>
          </v-row>
          <v-row no-gutters class="mr-2" justify="start">
            <v-btn @click="beforeRoute" small outlined class="mr-2 rounded text-capitalize" tile
              color="primary"><v-icon>keyboard_backspace</v-icon> Volver</v-btn>

            <v-btn v-if="hasFeature('SHOP-119')"  @click="dialog = true" small outlined class="mr-2 rounded text-capitalize" tile
              color="primary">
              <v-icon left>edit</v-icon>
              Editar
            </v-btn>
            <v-btn :disabled="hide_print_btn" @click="downloadInvoice" small outlined
              class="mx-2 rounded text-capitalize" tile color="primary">
              <v-icon left> print </v-icon>
              Imprimir
            </v-btn>

            <v-spacer></v-spacer>

            <!-- <v-btn
              v-if="data_order[0]?.last_status_id == 1"
              @click="sendOrder"
              small
              outlined
              class="mx-2 rounded text-capitalize"
              tile
              color="success"
            >
              <v-icon left> mdi-send-outline </v-icon>
              Enviar
            </v-btn> -->
            <v-btn v-if="(statusAproved && data_order[0]?.last_status_id < 10) || ($store.state.auth.globalFeatures.includes('SHOP-217') && data_order[0]?.last_status_id>1)" @click="devolverOrden" small
              outlined class="mx-2 rounded text-capitalize" tile color="orange dark-2">
              <v-icon left> keyboard_backspace </v-icon>
              Devolver
            </v-btn>

            <v-btn v-if="statusAproved || $store.state.auth.globalFeatures.includes('SHOP-116') || is_draft_owner"
              v-show="![11, 12, 14].includes(data_order[0]?.last_status_id)" @click="AprovedOrReject(11)" small outlined
              class="mx-2 rounded text-capitalize" tile color="red dark-2">
              <v-icon left> thumb_down </v-icon>
              Cancelar
            </v-btn>

            <v-btn v-if="emergency_approver" @click="approve_emergency()" small outlined
              class="mx-2 rounded text-capitalize" tile color="success">
              <v-icon left> thumb_up </v-icon>
               Aprobar emergencia
            </v-btn>
            <v-btn :disabled="presupuesto_excedido" v-if="statusAproved" @click="AprovedOrReject(1)" small outlined
              class="mx-2 rounded text-capitalize" tile color="success">
              <v-icon left> thumb_up </v-icon>
              {{ approved_button }}
            </v-btn>
            <v-tooltip bottom v-if="presupuesto_excedido">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" small outlined class="mx-2 rounded text-capitalize" tile color="red"
                  @click="tab = 1">
                  <v-icon left small>mdi-chart-bar</v-icon>
                  PRESUPUESTO EXCEDIDO
                </v-btn>
              </template>
              <span>{{ presupuesto_mensaje || 'Una partida cerrada de esta orden no tiene disponible.' }}</span>
            </v-tooltip>
            <v-btn v-if="data_order[0]?.last_status_id === 13 && is_reception == true && hasFeature('SHOP-132')" @click="dialog = true" small
              outlined class="mr-2 rounded text-capitalize" tile color="green">
              <v-icon left>warehouse</v-icon>
              Hacer Recepción
            </v-btn>
            <v-btn
              v-if="![1, 2, 11, 12, 14].includes(data_order[0]?.last_status_id) && $store.state.auth.globalFeatures.includes('SHOP-114')"
              @click="AprovedOrReject(14)" small outlined class="mr-2 rounded text-capitalize" tile color="blue">
              <v-icon left>lock</v-icon>
              Cerrar orden
            </v-btn>
            <v-btn
              v-if="data_order[0]?.last_status_id == 14 && cant_reopen_order && $store.state.auth.globalFeatures.includes('SHOP-117')"
              @click="reopen_order()" small outlined class="mr-2 rounded text-capitalize" tile color="blue">
              <v-icon left>lock_open</v-icon>
              Reabrir orden
            </v-btn>
          </v-row>
          <v-row class="mt-4" no-gutters justify="center">
            <div class="folded_corner mt-5 overflow-hidden position-relative">
              <!-- Sello de Estado (Watermark Stamp) -->
              <!-- <div v-if="data_order[0]?.last_status_id === 14" class="status-stamp closed">
                CERRADA
              </div>
              <div v-else-if="[11, 12].includes(data_order[0]?.last_status_id)" class="status-stamp cancelled">
                {{ data_order[0]?.last_status_name?.toUpperCase() }}
              </div> -->

              <v-row class="mt-8" justify="center">
                <v-col cols="2" md="3">
                  <v-row justify="center">
                    <v-img contain width="100px" height="100px" :src="locationImage"></v-img>
                  </v-row>
                </v-col>
                <v-col cols="2" md="6">
                  <v-row justify="center">
                    <span class="font-weight-bold" style="font-size: 20px; color: #616161">{{
                      data_order[0]?.business_unit_description_long }}</span>
                  </v-row>

                  <v-row justify="center">
                    <span style="font-size: 16px; color: #616161">{{
                      data_order[0]?.location_description_long
                      }}</span>
                  </v-row>

                  <v-row justify="center">
                    <span style="font-size: 16px; color: #616161"> </span>
                  </v-row>
                  <v-row justify="center">
                    <span style="font-size: 14px; color: #616161"> </span>
                  </v-row>
                  <v-row justify="center"> </v-row>
                </v-col>
                <v-col cols="2" md="3" align="end">
                  <v-row justify="end">
                    <span class="mr-6 mt-0" style="font-size: 24px; color: #616161">#{{
                      filLeft(data_order[0]?.order_id.toString(), 12, "0") }}
                    </span>
                  </v-row>
                  <v-row no-gutters justify="end" class="py-3 pr-3 mt-3">
                    <v-col cols="2" md="10">
                      <span>Creacion
                        <b>{{ getDate(data_order[0]?.created_at) }}</b>
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col cols="2" md="8">
                  <span class="ml-16">Proveedor:</span>
                  <span @click="viewEntity(data_order[0]?.entity_id)"
                    style="text-decoration: underline; cursor: pointer" class="mx-4 font-weight-bold">{{
                      data_order[0]?.entity_name }}</span>
                </v-col>
                <v-col cols="2" md="4">
                  <span class="mr-12 float-right">Terminos de pago
                    <b>{{ data_order[0]?.credit_days_description || 'N/A' }}</b>
                  </span>
                </v-col>
                <v-divider inset class="mr-8"></v-divider>
              </v-row>
              <v-row justify="center">
                <v-col cols="2" md="6">
                  <span class="ml-16">RNC o Cédula :</span>
                  <span class="ml-2">{{ data_order[0]?.rnc }}</span>
                </v-col>
                <v-col cols="2" md="6">
                  <span class="mr-12 float-right">Almacen:
                    <span class="mx-5 font-weight-bold">{{
                      data_order[0]?.warehouse_name || 'N/A'
                      }}</span>
                  </span>
                </v-col>
                <v-divider inset class="mr-8"></v-divider>
              </v-row>



              <v-row v-if="data_order[0]?.quotation_id != null" justify="center" class="mt-4">
                <v-col cols="2" md="6">
                  <span class="ml-16">Cotizacion: </span>
                  <span style="text-decoration: underline; cursor: pointer" @click="goQuotation(data_order[0])"
                    class="mx-2 font-weight-bold">
                    {{ filLeft(data_order[0]?.quotation_id.toString(), 12, "0") }}</span>
                </v-col>
                <v-col cols="2" md="6">
                  <span class="mr-12 float-right">Proyecto {{ orderProjects }}
                  </span>
                </v-col>
                <!-- <v-divider inset class="mr-8"></v-divider> -->
              </v-row>

              <v-row justify="center" class="mt-7">
                <v-col cols="12" md="11">
                  <v-container class="">
                    <v-data-table :headers="headers" dense :items-per-page="200" :items="data_order[0]?.order_details"
                      class="elevation-0 rounded-lg custom-table" hide-default-footer>
                      <template v-slot:item.index="{ index }">
                        <span class="grey--text text--darken-1">{{ index + 1 }}</span>
                      </template>
                      <template v-slot:[`item.item_name`]="{ item }">
                        <div class="d-flex flex-column py-2">
                          <span class="font-weight-bold grey--text text--darken-4">
                            {{ item.item_name }}
                            <v-chip v-if="item.is_offer" x-small color="deep-purple" dark
                              class="ml-2 font-weight-bold">Oferta</v-chip>
                          </span>
                          <span v-if="item.warehouse_name" class="text-caption grey--text d-flex align-center">
                            <v-icon x-small class="mr-1">mdi-warehouse</v-icon>{{ item.warehouse_name }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:[`item.unit_name`]="{ item }">
                        <v-chip x-small outlined label color="grey darken-1">{{ item.unit_name || 'N/A' }}</v-chip>
                      </template>
                      <template v-slot:[`item.item_chart_of_account_id`]="{ item }">
                        <span>{{ item.item_chart_of_account_id }} </span>
                      </template>
                      <template v-slot:[`item.price`]="{ item }">
                        <span>
                          {{
                            currencyFormat(item.price * item.tax_value + item.price)
                          }} {{ data_order[0]?.currency_code }}</span>
                      </template>
                      <template v-slot:[`item.discount`]="{ item }">
                        <span>

                          {{
                            currencyFormat(item.discount * item.price * item.quantity)
                          }} {{ data_order[0]?.currency_code }}</span>
                      </template>
                      <template v-slot:[`item.sub_total`]="{ item }">
                        <span>

                          {{ currencyFormat(item.price * item.quantity) }} {{ data_order[0]?.currency_code }}
                        </span>
                      </template>

                      <template v-slot:[`item.itbis`]="{ item }">
                        <span>

                          {{
                            currencyFormat(
                              (item.price - item.price * item.discount) *
                              item.quantity *
                              item.tax_value
                            )
                          }} {{ data_order[0]?.currency_code }}
                        </span>
                      </template>
                      <template v-slot:[`item.total`]="{ item }">
                        <span>

                          {{
                            currencyFormat(
                              (item.price - item.price * item.discount) *
                              item.quantity *
                              (1 + item.tax_value)
                            )
                          }} {{ data_order[0]?.currency_code }}
                        </span>
                      </template>
                      <template v-slot:footer>
                        <v-row class="mt-2" justify="center" style="margin-right: 0.5em">
                          <v-col cols="12" md="4">
                            <v-row style="margin-bottom: 130px" justify="center" class="mt-4">
                              <v-col cols="12">
                                <v-row>
                                  <span class="font-weight-bold ml-6">Notas</span>
                                </v-row>

                                <v-row>
                                  <span class="ml-8" v-if="data_order[0]?.comments">
                                    {{ getCommentText(data_order[0]?.comments) }}
                                  </span>
                                </v-row>
                                <v-row class="mt-0" justify="start" style="margin-right: 0.5em">
                                  <v-col cols="12" md="4">
                                    <v-row class="mt-4">
                                      <v-col cols="12">
                                        <v-row class="mt-4">
                                          <span class="font-weight-bold ml-6">Referencia</span>
                                        </v-row>
                                        <v-row>
                                          <span class="ml-8">
                                            {{ data_order[0]?.order_histories[0]?.metadata?.reference || 'N/A' }}
                                          </span>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="8">
                            <v-row justify="end">
                              <v-card style="margin-top: 30px; margin-bottom: 30px" elevation="0" width="30%"
                                height="100px">
                                <v-layout fill-height align-center>
                                  <v-col cols="12" md="12">
                                    <v-row justify="end">
                                      <span>
                                        Subtotal:
                                        <span>

                                          {{ currencyFormat(sub_total) }} {{ data_order[0]?.currency_code }}
                                        </span>
                                      </span>
                                    </v-row>
                                    <v-row justify="end">
                                      <span>
                                        Descuento:
                                        <span>

                                          {{ currencyFormat(total_discount_amount) }} {{ data_order[0]?.currency_code }}
                                        </span>
                                      </span>
                                    </v-row>
                                    <v-row justify="end">
                                      <span>
                                        ITBIS:
                                        <span>

                                          {{ currencyFormat(total_itbis) }} {{ data_order[0]?.currency_code }}
                                        </span>
                                      </span>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12" md="6">
                                    <v-row justify="end"> </v-row>
                                    <v-row justify="end">
                                      <span class="font-weight-normal"> </span>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="12" md="1"></v-col>
                                </v-layout>
                                <v-divider class="mt-2"></v-divider>
                                <v-row class="mt-2" justify="end" align="center">
                                  <div class="d-flex flex-column align-end mr-4">
                                    <span style="font-size: 1.2vh; color: #9e9e9e"
                                      class="text-uppercase font-weight-bold">
                                      {{ data_order[0]?.currency_name }}
                                    </span>
                                    <span style="font-size: 3vh; color: #1a237e" class="font-weight-black">
                                      Total
                                    </span>
                                  </div>
                                  <span style="font-size: 2vh; color: #1a237e" class="mx-1 font-weight-normal mt-2">{{
                                    data_order[0]?.currency_code }}</span>
                                  <span style="font-size: 3.5vh; color: #1a237e" class="font-weight-black ml-3">
                                    {{ currencyFormat(total) }}
                                  </span>
                                </v-row>
                              </v-card>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row class="mt-14 mb-14 px-10" justify="space-between" align="end">
                          <!-- Elaborado por -->
                          <v-col cols="12" md="5" class="text-center">
                            <div class="signature-box">
                              <div class="signature-line"></div>
                              <span class="font-weight-bold d-block grey--text text--darken-3">
                                Elaborado por
                              </span>
                              <span class="text-subtitle-2 grey--text">{{ data_order[0]?.use_fullname }}</span>
                            </div>
                          </v-col>

                          <!-- Aprobado por (Firma Digital) -->
                          <v-col v-if="data_order[0]?.last_orders_approval" cols="12" md="5" class="text-center">
                            <div class="signature-box">
                              <img v-if="data_order[0]?.last_orders_approval?.signature_url"
                                :src="signatureImageUrl"
                                alt="Firma de aprobación"
                                style="height:80px; max-width:220px; object-fit:contain; display:block;"
                              />
                              <div v-else class="signature-placeholder grey--text text--lighten-2">
                                <v-icon size="50">mdi-fountain-pen-tip</v-icon>
                              </div>
                              <div class="signature-line"></div>
                              <span class="font-weight-bold d-block grey--text text--darken-3">
                                {{ data_order[0]?.last_orders_approval?.order_status_name || 'Aprobado por' }}
                              </span>
                              <span class="text-subtitle-2 grey--text">{{
                                data_order[0]?.last_orders_approval?.user_fullname }}</span>
                            </div>
                          </v-col>
                        </v-row>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-col>
              </v-row>
            </div>
          </v-row>

          <v-row class="mt-8" no-gutters justify="center">
            <v-col cols="12" md="12"><v-card height="auto">
                <v-tabs v-model="tab" background-color="grey lighten-5">
                  <v-tab v-for="(item, i) in items" :key="i">
                    <v-icon left small>{{ item.icon }}</v-icon>
                    <span class="text-capitalize">{{ item.text }}</span>
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <!-- EDICION DE Contabilidad -->
                    <v-container fluid>
                      <v-row class="mt-0" justify="center">
                        <v-col cols="12" md="12">
                          <PreAccounting v-if="parsedEntries.length > 0" @set_accounts="setAccounts"
                            :order_item_entries="parsedEntries" :search_names="false" :totalOrderAmount="total"
                            :cant_edit="$store.state.auth.globalFeatures.includes('SHOP-142') && data_order[0]?.last_status_id > 1"
                            :show_credits="false" />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container fluid class="px-6">
                      <v-alert v-if="presupuesto_excedido" dense outlined type="error" class="mb-4 rounded-lg">
                        {{ presupuesto_mensaje }} No se puede aprobar la orden hasta ajustar el presupuesto.
                      </v-alert>
                      <v-alert v-else-if="presupuesto.length === 0" dense outlined type="info" class="mb-4 rounded-lg">
                        Esta orden no tiene partidas presupuestarias definidas para el período contable actual,
                        por lo que no aplica control de presupuesto.
                      </v-alert>

                      <!-- Resumen de Presupuesto -->
                      <v-row class="mb-4">
                        <v-col cols="12" md="4">
                          <v-card outlined class="rounded-xl pa-4 text-center" color="blue lighten-5">
                            <div class="text-overline grey--text">Total Presupuesto</div>
                            <div class="text-h5 font-weight-black primary--text">
                              {{ currencyFormat(totalPresupuesto) }}
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-card outlined class="rounded-xl pa-4 text-center" color="orange lighten-5">
                            <div class="text-overline grey--text">Total Consumido</div>
                            <div class="text-h5 font-weight-black orange--text text--darken-3">
                              {{ currencyFormat(totalConsumido) }}
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-card outlined class="rounded-xl pa-4 text-center" color="green lighten-5">
                            <div class="text-overline grey--text">Total Disponible</div>
                            <div class="text-h5 font-weight-black success--text">
                              {{ currencyFormat(totalDisponible) }}
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>

                      <v-card outlined class="rounded-xl overflow-hidden">
                        <v-data-table
                          :headers="headerPresupuesto"
                          :items="presupuesto"
                          class="elevation-0"
                          hide-default-footer
                        >
                          <template v-slot:[`item.department_description`]="{ item }">
                            <div class="d-flex flex-column">
                              <span class="font-weight-bold">
                                {{ item.department_description }}
                                <v-tooltip bottom v-if="!item.applies_to_order">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" x-small class="ml-1" color="grey">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>
                                    Partida informativa: comparte la cuenta contable pero no corresponde
                                    al departamento/categoría de esta orden, por lo que no la bloquea.
                                  </span>
                                </v-tooltip>
                              </span>
                              <span class="text-caption grey--text">{{ item.chart_of_accounts_name }}</span>
                            </div>
                          </template>
                          <template v-slot:[`item.total_budget`]="{ item }">
                            <span class="font-weight-medium">{{ currencyFormat(item.total_budget) }}</span>
                          </template>
                          <template v-slot:[`item.total_consumed`]="{ item }">
                            <span class="orange--text text--darken-2">{{ currencyFormat(item.total_consumed) }}</span>
                          </template>
                          <template v-slot:[`item.remaining_amount`]="{ item }">
                            <v-chip
                              small
                              label
                              :color="parseFloat(item.remaining_amount) <= 0 ? 'red lighten-5' : 'green lighten-5'"
                              :class="parseFloat(item.remaining_amount) <= 0 ? 'red--text text--darken-2' : 'green--text text--darken-2'"
                              class="font-weight-bold"
                            >
                              {{ currencyFormat(item.remaining_amount) }}
                            </v-chip>
                          </template>
                          <template v-slot:[`item.percent`]="{ item }">
                            <div class="d-flex align-center">
                              <v-progress-linear
                                :value="100 - progress(item).value"
                                :color="progress(item).color"
                                height="10"
                                rounded
                                class="mr-3"
                                style="width: 100px"
                              ></v-progress-linear>
                              <span class="text-caption font-weight-bold" :class="progress(item).color + '--text'">
                                {{ 100 - progress(item).value }}%
                              </span>
                            </div>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="mt-2 mb-2" justify="center">
                      <v-col cols="12" md="11">
                        <v-data-table :headers="headerReceptions" :items="data_entry_order"
                          class="elevation-0 rounded-lg mt4 mb-4" style="">
                          <template v-slot:[`item.id`]="{ item }">
                            <span @click="
                              viewReception(data_order[0]?.order_id, item.entry_id)
                              " style="text-decoration: underline; cursor: pointer" class="primary--text">
                              {{ filLeft(item.entry_id.toString(), 12, "0") }}
                            </span>
                          </template>
                          <template v-slot:[`item.monto`]="{ item }">
                            <span class="font-weight-medium">
                              {{ currencyFormat(item.order_item_entries.reduce((t, i) => t + parseFloat(i.quantity) * parseFloat(i.price), 0)) }} {{ item.currency_code }}
                            </span>
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-btn icon color="error" @click="delente_entry(item)"
                              v-if="$store.state.auth.globalFeatures.includes('SHOP-115')">
                              <v-icon>
                                delete_forever
                              </v-icon>
                            </v-btn>
                          </template>
                          <template v-slot:body.append>
                            <tr class="grey lighten-5">
                              <td colspan="4" class="text-right font-weight-black">TOTAL RECEPCIONES</td>
                              <td class="text-right primary--text font-weight-black">
                                {{ currencyFormat(data_entry_order.reduce((t, entry) => t + entry.order_item_entries.reduce((s, i) => s + parseFloat(i.quantity) * parseFloat(i.price), 0), 0)) }} {{ data_entry_order[0]?.currency_code }}
                              </td>
                              <td></td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="mt-0" justify="center">
                      <v-col cols="12" md="11">
                        <v-data-table :headers="header_invoices" :items="invoices"
                          class="elevation-0 rounded-lg mt4 mb-4">
                          <template v-slot:[`item.invoice_number`]="{ item }">
                            <v-hover v-slot="{ hover }">
                              <span @click="showInvoice(item.invoice_id, true)"
                                class="primary--text font-weight-normal text-truncate font-weight-semibold" :style="{
                                  color: hover ? 'red' : 'black',
                                  cursor: hover ? 'pointer' : '',
                                  'text-decoration': hover ? 'underline' : '',
                                }">
                                {{ item.invoice_number }}
                              </span>
                            </v-hover>
                            <br />
                          </template>
                          <template v-slot:[`item.total_amount`]="{ item }">
                            <span>
                              {{ item.currency_code }} ${{ currencyFormat(item.total_amount) }}
                            </span>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-col>
          </v-row>
          <!-- Ruta de Aprobación -->
          <v-row v-if="data_order[0]?.orders_approvals && data_order[0]?.orders_approvals.length > 0" class="mt-8 mb-4"
            no-gutters justify="center">
            <v-col cols="12" md="12">
              <v-card class="approval-path-card elevation-0 rounded-xl">
                <v-card-title class="pb-2">
                  <v-icon color="primary" class="mr-2">mdi-gesture-double-tap</v-icon>
                  <span class="text-h6 font-weight-bold grey--text text--darken-3">Flujo de Aprobación</span>
                </v-card-title>
                <v-card-text>
                  <div class="approval-path custom-scrollbar">
                      <div v-for="(approval, index) in filteredApprovals" :key="index"
                      class="approval-step position-relative">
                        <!-- Floating Check Badge -->
                        <div v-if="isStepApproved(approval)" class="step-check-badge">
                          <v-icon color="white" size="18">mdi-check-bold</v-icon>
                        </div>

                        <div class="step-container">
                          <v-avatar size="44" class="step-avatar">
                            <span class="white--text font-weight-bold text-uppercase">{{
                              getInitials(approval.use_fullname)
                              }}</span>
                          </v-avatar>
                          <div class="step-info">
                            <div class="text-subtitle-2 font-weight-black grey--text text--darken-4 text-truncate"
                              style="max-width: 220px;">
                              {{ approval.use_fullname }}
                            </div>
                            <!-- Show limits for debug/clarity -->
                            <!-- <div class="text-caption grey--text">
                              Límite: {{ currencyFormat(approval.limit_amount) }} USD
                            </div> -->
                          </div>
                          <!-- Solo usuarios con SHOP-218 pueden reenviar la notificación. -->
                          <v-tooltip bottom v-if="$store.state.auth.globalFeatures.includes('SHOP-218') && isCurrentApprover(approval)">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" icon small color="primary"
                                :loading="resendingApprovalEmail"
                                :disabled="resendingApprovalEmail || approvalEmailResent"
                                @click="resendApprovalEmail">
                                <v-icon size="22">mdi-email-fast-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Reenviar notificación a {{ approval.use_fullname }}</span>
                          </v-tooltip>
                        </div>
                      <div v-if="index < filteredApprovals.length - 1" class="step-connector mx-4">
                        <v-icon large>mdi-chevron-right</v-icon>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-8 mb-14" no-gutters justify="center">
            <v-col cols="12" md="8">
              <v-card class="mr-6" min-height="400">
                <v-card-title style="font-size: 18px; color: #424242" class="pb-0 d-flex justify-center">
                  Historico orden #{{
                    filLeft(data_order[0]?.order_id.toString(), 12, "0")
                  }}
                </v-card-title>
                <v-divider class="ma-4"></v-divider>

                <v-responsive :aspect-ratio="16 / 9">
                  <v-container fluid>
                    <template>
                      <v-timeline>
                        <v-timeline-item v-for="item in data_order[0]?.order_histories" small
                          :key="item.item_request_status_id" :color="time_line_orders(item.order_status_id).color"
                          :icon="time_line_orders(item.order_status_id).icon" class="pb-0">
                          <template v-slot:opposite>
                            <span>{{ item.use_fullname }}</span>
                          </template>

                          <v-card outlined>
                            <v-card-title class="d-flex align-center pt-0 pb-0"
                              :class="time_line_orders(item.order_status_id).color">

                              <!-- Extremo izquierdo: acción realizada desde correo -->
                              <v-tooltip bottom v-if="item.metadata?.via_email">
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" small color="white">mdi-email-check</v-icon>
                                </template>
                                <span>Acción realizada desde correo electrónico</span>
                              </v-tooltip>
                              <span v-else style="width:20px;display:inline-block"></span>

                              <!-- Centro: fecha -->
                              <span class="flex-grow-1 text-center" style="font-size:14px;color:#ffffff">
                                {{ dateFormated(item.created_date) }}
                              </span>

                              <!-- Extremo derecho: resultado del correo al siguiente aprobador -->
                              <v-tooltip bottom v-if="item.metadata?.email_sent_to_next_approver">
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" small
                                    :color="item.metadata.email_sent_to_next_approver === 'error' ? 'red lighten-3'
                                          : item.metadata.email_sent_to_next_approver === 'omitido' ? 'grey lighten-2'
                                          : 'white'">
                                    {{ item.metadata.email_sent_to_next_approver === 'error'   ? 'mdi-email-alert'
                                      : item.metadata.email_sent_to_next_approver === 'omitido' ? 'mdi-email-off'
                                      : 'mdi-email-fast' }}
                                  </v-icon>
                                </template>
                                <span>{{
                                  item.metadata.email_sent_to_next_approver === 'error'
                                    ? 'Error al enviar notificación al siguiente aprobador'
                                    : item.metadata.email_sent_to_next_approver === 'omitido'
                                      ? 'Notificaciones del siguiente aprobador desactivadas'
                                      : `Notificación enviada a ${item.metadata.email_sent_to_next_approver}`
                                }}</span>
                              </v-tooltip>
                              <span v-else style="width:20px;display:inline-block"></span>

                            </v-card-title>

                            <v-card-text>
                              <span class="d-flex justify-center align-center">
                                {{ item.name }}
                              </span>
                            </v-card-text>

                            <v-card-text v-if="item.metadata?.nota" class="nota-destacada">
                              <v-icon small class="mr-2" color="orange darken-2">mdi-note-text</v-icon>
                              <strong>{{ item.metadata.nota }}</strong>
                            </v-card-text>
                          </v-card>
                        </v-timeline-item>
                      </v-timeline>
                    </template>
                  </v-container>
                </v-responsive>
              </v-card>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="4">
              <v-card v-if="selectedAttached == '' && !hasAttached" width="80%" @click="hasFeature('SHOP-119') ? takeImage() : null" style="
                  cursor: pointer;
                  border: 0.5px solid rgb(0, 0, 0);
                  border-radius: 6px;
                  background-color: #fafafa;
                " class="mx-2 mt-6 align-self-center" outlined>
                <v-row no-gutters justify="center">
                  <v-card-title class="headline">Archivos adjuntos </v-card-title>
                </v-row>
                <v-row class="mb-4" no-gutters justify="center">
                  <v-icon style="transform: rotate(30deg)" size="60px">
                    attach_file
                  </v-icon>
                </v-row>
              </v-card>
              <!-- Adjunto que el navegador no puede mostrar (word, excel, zip, etc.):
                   se ofrece descarga manual, nunca automatica. -->
              <v-card v-else-if="!attachedPreviewable" width="80%" outlined
                class="mx-2 mt-6 align-self-center" style="border-radius: 6px; background-color: #fafafa;">
                <v-row no-gutters justify="center">
                  <v-card-title class="headline">Archivo adjunto</v-card-title>
                </v-row>
                <v-row class="mb-2" no-gutters justify="center">
                  <v-icon size="60px">mdi-file-document-outline</v-icon>
                </v-row>
                <v-row class="mb-4 px-4" no-gutters justify="center">
                  <span class="text-caption grey--text text--darken-2 text-center">
                    {{ attachedName }}
                  </span>
                </v-row>
                <v-card-actions class="d-block">
                  <v-btn outlined color="primary" block :loading="downloadingAttachment"
                    @click="downloadAttached()">
                    <v-icon left>mdi-download</v-icon> Descargar
                  </v-btn>
                  <v-btn v-if="hasFeature('SHOP-119')" outlined color="error" block class="mt-2 ml-0" @click="delete_adjunto()">Eliminar</v-btn>
                </v-card-actions>
              </v-card>
              <div class="align-self-center mb-10" v-else style="
                    position: relative;
                    /* padding-bottom: 56.25%; /* 16:9 */
                    /* padding-top: 25px; */
                    /* height: 0; */
                    display: flex; /* Usamos flexbox para una mejor alineación */
                    flex-direction: column; /* Apilamos los elementos verticalmente */
                  ">
                <div style="flex-grow: 1; position: relative;">
                  <iframe title="Documento adjunto" style="width: 100%; height: 55vh" :src="selectedAttached" frameborder="0">
                  </iframe>
                </div>
                <v-divider></v-divider>
                <v-btn v-if="hasFeature('SHOP-119')" outlined color="error" @click="delete_adjunto()" block>Eliminar</v-btn>
              </div>
            </v-col>
            <v-file-input v-show="false" style="opacity: 0" name="upload" id="fileInput"
              @change="onFileChange"></v-file-input>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-dialog transition="slide-x-transition" v-model="dialog" fullscreen persistent>
      <v-card style="background-color: #f4f5fa">
        <v-toolbar flat dark color="transparent">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title> </v-toolbar-title>
        </v-toolbar>
        <v-container fluid>
          <v-row justify="center">
            <v-col cols="12" md="11">
              <Order v-if="dialog" :data_order="data_order" :is_reception="is_reception"
                :original_amount="last_approved_amount" @save-order="editOrder($event)" />
            </v-col>
          </v-row>
        </v-container>
        <v-card-text>
          <v-row> </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Reason Dialog -->
    <v-dialog v-model="reasonDialog" width="40%">
      <v-card>
        <v-card-title><v-icon color="warning">warning</v-icon> {{ dialogTitle }}</v-card-title>
        <v-card-text>
          <v-textarea v-model="cancelReason" label="Motivo" outlined rows="3"
            :rules="[(v) => !!v || 'El motivo es requerido']" required></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="reasonDialog = false">
            No, cancelar
          </v-btn>
          <v-btn text color="success" @click="confirmAction" :disabled="!cancelReason">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogConfirm :showDialog="dialog_confirm" :loading="loading_entry_delete" :confirm_settings="{
      title: 'Seguro que desea eliminar esta entrada?',
      btn_affirmative: 'Continuar',
      btn_negative: 'Cancelar',
      icon: 'mdi-alert-circle',
      size: '45%',
    }" @closeDialog="confirm_delete_entry"></DialogConfirm>
  </v-container>
</template>

<script>
import moment from "moment";
import Order from "./Order.vue";
import momentTimezone from "moment-timezone";
import PreAccounting from "@/components/Accounting/PreAccounting.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";
export default {
  data: () => ({
    dialog: false,
    hasFiles: false,
    search: "",
    dialog_confirm: false,
    entry_to_delete: null,
    loading_entry_delete: false,
    is_reception: false,
    selectedAttached: "",
    loadingAttachment: false,
    attachedName: "",
    attachedKey: "",
    attachedPreviewable: false,
    downloadingAttachment: false,
    dialogAttached: false,
    date: moment().startOf("month").format("YYYY-MM-DD"),
    date2: moment().startOf("month").format("YYYY-MM-DD"),
    id_orders: null,
    storage_invoice: "",
    data_order: null,
    detailsItems: [],
    tab: null,
    paymentsInvoice: [],
    reponse_level: [],
    locationImage: null,
    storage_json: [],
    items: [
      { text: "Contabilidad", icon: "mdi-calculator" },
      { text: "Presupuesto", icon: "mdi-chart-bar" },
      { text: "Recepciones", icon: "mdi-warehouse" },
      { text: "Facturas", icon: "mdi-file-document-outline" }
    ],
    header_invoices: [
      {
        text: "FACTURA",
        align: "start",
        sortable: false,
        value: "invoice_number",
      },
      { text: "Factura suplidor", value: "supplier_invoice_number", align: "center" },
      { text: "Comprobante suplidor", value: "supplier_invoice_voucher", align: "center" },
      { text: "Fecha", value: "emission_date" },

      { text: "Monto", value: "total_amount", align: "right" },
    ],
    headerReceptions: [
      {
        text: "Recepcion",
        align: "start",
        sortable: false,
        value: "id",
      },
      { text: "Almacen", value: "warehouses_name" },
      { text: "Fecha", value: "created_date", align: "start" },
      { text: "Usuario", value: "user_fullname", align: "start" },
      { text: "Monto", value: "monto", align: "right" },
      { text: "", value: "actions", align: "end" },
    ],
    headerPresupuesto: [
      {
        text: "Departamento",
        align: "start",
        sortable: false,
        value: "department_description",
      },
      { text: "Cuenta", value: "chart_of_accounts_name" },
      { text: "Categoria", value: "category_name" },
      { text: "Subcategoria", value: "subcategory_name" },
      { text: "Total presupuesto", value: "total_budget", align: "start" },
      { text: "Consumido", value: "total_consumed", align: "start" },
      { text: "Disponible", value: "remaining_amount", align: "start" },
      { text: "% Porcentaje", value: "percent", align: "start" },
    ],
    reasonDialog: false,
    cancelReason: "",
    loadingSave: false,
    resendingApprovalEmail: false,
    approvalEmailResent: false,
    is_emergency_approval: false,
    selectedAction: null,
    dialogTitle: "",
    array_reason_titles: [{ id: 11, text: "cancelar esta orden" }, { id: 12, text: "devolver esta orden" }, { id: 14, text: "cerrar esta orden" }],
    itbis: [],
    data_entry_order: [],
    invoices: [],
    presupuesto: [],
    presupuesto_excedido: false,
    presupuesto_mensaje: "",
    headersInventario: [{}],
    headers: [
      { text: "#", value: "index" },
      {
        text: "ID",
        align: "start",
        sortable: false,
        value: "item_id",
      },
      {
        text: "Producto/servicio",
        align: "start",
        sortable: false,
        value: "item_name",
        width: "30%"
      },
      { text: "Unidad", value: "unit_name", align: "center" },
      { text: "Precio", value: "price", align: "end", width: "12%" },
      //   { text: "	Desc %", value: "", align: "end" },

      { text: "Cant.", value: "quantity", align: "end" },
      { text: "Sub total", value: "sub_total", align: "end" },
      { text: "Desc.", value: "discount", align: "end", width: "10%" },
      { text: "ITBIS", value: "itbis", align: "end", width: "10%" },
      { text: "Total", value: "total", align: "end" },
    ],
    itemsFiles: [],
    headersFiles: [
      {
        text: "Descripcion",
        align: "start",
        sortable: false,
        value: "description",
      },

      { text: "	Action", value: "actions", align: "end" },
    ],
    level: [],
    others_orders: [],
    next_order_data: null,
    commentHeader: "",
  }),
  components: { Order, PreAccounting, DialogConfirm },
  computed: {
    orderProjects() {
      // Concatena los codigos de proyecto (distintos) presentes en el detalle de la orden.
      // El proyecto se guarda por linea en order_details (project_code/project_name).
      const details = this.data_order?.[0]?.order_details || [];
      const codes = [
        ...new Set(
          details
            .filter((d) => d.project_code != null && d.project_code !== "")
            .map((d) => d.project_code)
        ),
      ];
      return codes.length ? codes.join(", ") : "N/A";
    },
    cant_reopen_order() {
      if (!this.data_order || !this.data_order[0] || !this.data_order[0].order_details) {
        return false;
      }
      for (let item of this.data_order[0].order_details) {
        if (parseFloat(item.entry_quantity || 0) < parseFloat(item.quantity)) {
          return true;
        }
      }
      return false;
    },
    parsedEntries() {
      if (!this.data_order || this.data_order.length === 0 || !this.data_order[0] || !this.data_order[0].order_details) {
        return [];
      }
      const currency_code = this.data_order[0]?.currency_code;
      return this.data_order[0].order_details.map(detail => ({
        item_id: detail.item_id,
        item_name: detail.item_name,
        entry_id: detail.request_id,
        // clave única por línea: incluye sequence para no colapsar la oferta (mismo item/solicitud) con la pagada
        key: `${detail.item_id}_${detail.request_id}_${detail.sequence}`,
        sequence: detail.sequence,
        price: detail.price - (detail.price * detail.discount),
        quantity: detail.quantity,
        currency_code: currency_code == undefined ? 'USD' : currency_code,
        order_chart_of_accounts: !detail.order_chart_of_accounts ? [] : detail.order_chart_of_accounts.map(account => ({
          chart_of_account_id: account.chart_of_account_id,
          chart_of_account_name: account.chart_of_account_name,
          chart_of_account_code: account.chart_of_account_code || null,
          category_id: account.category_id || null,
          subcategory_id: account.subcategory_id || null,
          department_id: account.department_id,
          entry_type_id: account.entry_type_id,
          location_id: account.location_id,
          amount: account.amount,
        }))
      }))
    },
    is_draft_owner() {
      // El creador de la orden puede cancelarla mientras siga en borrador
      return (
        this.data_order[0]?.last_status_id == 1 &&
        this.$store.state.auth.user.user.user_id == this.data_order[0]?.created_by
      );
    },
    hide_print_btn() {
      //SI LA ORDEN ESTA PENDIENTE DE IMPRESION Y SOLO EL USUARIO QUE REALIZO LA ORDEN PUEDE DARLE A IMPRIMIR
      if (
        this.data_order[0]?.last_status_id == 15 &&
        this.$store.state.auth.user.user.user_id != this.data_order[0]?.created_by &&
        !this.$store.state.auth.globalFeatures.includes("SHOP-144")
      ) {
        return true;
      }
      if (![13, 14, 15].includes(this.data_order[0]?.last_status_id)) {
        return true;
      }
      return false;
    },
    statusAproved() {
      let st = false;
      let userHasPendingApproval = false; // Nueva variable para almacenar el estado del usuario en el for
      const order = this.data_order[0];
      const userId = this.$store.state.auth.user.user.user_id;
      const features = this.$store.state.auth.globalFeatures;

      if (order?.orders_approval_user == userId) {
        userHasPendingApproval = true;
        st = true;
      }
      // Verifica si el usuario tiene una aprobación pendiente
      // for (let item of approvals) {
      //   if (item.last_status === null && item.user_id === userId) {
      //     userHasPendingApproval = true;
      //     break;
      //   }
      // }

      //Aplica regla s basadas en el estado del pedido y los permisos del usuario
      if (order?.last_status_id == 2 && features.includes("SHOP-142")) {
        st = true;
      }

      // if (
      //   userHasPendingApproval &&
      //   order.last_status_id > 2 &&
      //   order.last_status_id < 11 &&
      //   features.includes("SHOP-143")
      // ) {
      //   st = true;
      // }

      return st;
    },
    emergency_approver() {
      const order = this.data_order[0];
      const userId = this.$store.state.auth.user.user.user_id;
      if (![1,2,10,11,12,13,14,15].includes(order?.last_status_id) && this.$store.state.auth.globalFeatures.includes("SHOP-113") && order?.orders_approval_user != userId) {
        return true;
      }
      return false;
    },
    can_edit() {//arreglar
      if (this.data_entry_order.length > 0) {
        for (let item of this.data_entry_order) {
          if (item.invoice_id != null) {
            return true;
          }
        }
      }
      if (
        parseInt(this.data_order[0]?.last_status_id) == 12 ||
        parseInt(this.data_order[0]?.last_status_id) == 1
      ) {
        return false;
      }

      // if (parseInt(this.data_order[0]?.last_status_id) > 2 && !this.$store.state.auth.globalFeatures.includes('SHOP-112')) {
      //NO PUEDE EDITAR SI ESTA CANCELADA, RECHAZADA O CERRADA... 
      if ([11, 12, 14].includes(parseInt(this.data_order[0]?.last_status_id)) && !this.$store.state.auth.globalFeatures.includes('SHOP-112')) {
        return true;
      } else {
        return false;
      }
    },

    approved_button() {
      if (this.data_order[0]?.last_status_id == 2) {
        return "Aprobar Contador";
      } else {
        return "Aprobar";
      }
    },
    totalPresupuesto() {
      return this.sumPresupuesto("total_budget");
    },
    totalConsumido() {
      return this.sumPresupuesto("total_consumed");
    },
    totalDisponible() {
      return this.sumPresupuesto("remaining_amount");
    },
    is_approved() {
      if (this.$route.params.type == "a2xrbWFuaW4") {
        if (this.data_order[0]?.last_status_id == 1) {
          return false;
        }

        if (this.data_order[0]?.last_status_id == 11) {
          return false;
        }
        if (this.data_order[0]?.last_status_id == 12) {
          return false;
        } else {
          return true;
        }
      }
    },
    sub_total() {
      let tot = 0;
      if (this.data_order == null || this.data_order == undefined || this.data_order.length == 0) {
        return tot
      }
      for (let item of this.data_order[0].order_details) {
        tot += item.price * item.quantity;
      }
      return tot;
    },
    total_itbis() {
      let tot = 0;
      if (this.data_order == null || this.data_order == undefined || this.data_order.length == 0) {
        return tot
      }
      for (let item of this.data_order[0].order_details) {
        const precioConDescuento = item.price - item.price * item.discount;
        tot += precioConDescuento * item.quantity * item.tax_value;
      }
      return tot;
    },
    total() {
      let tot = 0;
      if (this.data_order == null || this.data_order == undefined || this.data_order.length == 0) {
        return tot
      }
      // if(this.data_order[0].last_approved_amount!=null){
      //   return this.data_order[0].last_approved_amount;
      // }
      for (let item of this.data_order[0].order_details) {
        const precioConDescuento = item.price - item.price * item.discount;
        tot += precioConDescuento * item.quantity * (1 + item.tax_value);
      }
      return tot;
    },
    last_approved_amount() {
      if (this.data_order != null && this.data_order != undefined && this.data_order.length > 0 && this.data_order[0].last_approved_amount != null) {
        const last_amount = this.data_order[0].last_approved_amount
        return parseFloat(last_amount);
      }
      return this.total;
    },
    total_discount_amount() {
      let total = 0;
      if (this.data_order == null || this.data_order == undefined || this.data_order.length == 0) {
        return total
      }
      for (let item of this.data_order[0].order_details) {
        const descuentoUnitario = item.price * item.discount;
        total += descuentoUnitario * item.quantity;
      }
      return total;
    },

    totalContabilidad() {
      let debito = 0;
      let credito = 0;

      return { debito: debito.toFixed(2), credito: credito.toFixed(2) };
    },
    signatureImageUrl() {
      const sig = this.data_order?.[0]?.last_orders_approval?.signature_url;
      if (!sig) return null;
      if (sig.startsWith('http')) return sig;
      return this.spaces_file_url(`signatures/${sig}`);
    },
    hasAttached() {
      return this.data_order?.[0]?.data_json?.key != null;
    },
    filteredApprovals() {
      if (!this.data_order || !this.data_order[0]) return [];
      const approvals = [...(this.data_order[0].orders_approvals || [])].sort(
        (a, b) => Number(a.limit_amount) - Number(b.limit_amount)
      );
      // Monto calculado en el backend igual que INVENTORY.ADD_ORDER_TO_HISTORY.
      const amount = Number(this.data_order[0].approval_amount);
      if (!Number.isFinite(amount)) return approvals;

      // Misma regla que la BD: el flujo es acumulativo hasta el primer paso cuyo
      // límite cubre el monto (no depende de init_amount, así un hueco entre
      // rangos no deja la orden sin último nivel). Si el monto supera todos los
      // límites, aplica la ruta completa.
      const finalIndex = approvals.findIndex(
        (approval) => amount <= Number(approval.limit_amount)
      );
      return finalIndex === -1 ? approvals : approvals.slice(0, finalIndex + 1);
    }
  },
  created() {
    if (this.$route.params.typeb == "a2xrbWFuaW4Rtgsdsx") {
      this.is_reception = true;
    }
    this.getData(true);
  },
  methods: {
    async get_user_orders() {
      try {
        // El usuario sale del token en el servidor
        const resultOrders = await this.api_Post("shopping/my_pending_approvals", {
          exclude_order_id: this.id_orders,
        });

        const data = await resultOrders.json();
        if (resultOrders.status === 200) {
          this.others_orders = data;
        }
      } catch (error) {
        console.error("Error fetching user orders:", error.message);
      }
    },
    async confirmAction() {
      if (!this.cancelReason) {
        this.$toast.error("Por favor ingrese un motivo");
        return;
      }
      if(this.is_emergency_approval==true){
        await this.confirm_emergency_approval();
        return;
      }
      let data = {
        order_id: this.id_orders,
        user_id: this.$store.state.auth.user.user.user_id,
        order_status_id: this.selectedAction,
        metadata: { nota: this.cancelReason, amount: this.total },
      };

      const responseApprove = await this.api_Post("shopping/approve_or_reject", data);
      if (responseApprove.status == 200) {
        this.getData(true);
        const messages = [{ id: 11, text: "cancelada" }, { id: 1, text: "devuelta" }, { id: 14, text: "cerrada" }];
        this.$toast.success(`Orden ${messages.find((element) => element.id == this.selectedAction).text} con exito!`);
        this.reasonDialog = false;
      } else {
        this.$toast.error(await this.readErrorMessage(responseApprove));
      }
    },
    async confirm_emergency_approval(){
        try {
             let data = {
              order_id: this.id_orders,
              user_id: this.$store.state.auth.user.user.user_id,
              order_status_id: this.data_order[0].last_status_id+1,
              metadata: { nota: `⚠️ Aprobacion de emergencia: ${this.cancelReason}`, amount: this.total },
            };

            const responseApprove = await this.api_Post("shopping/emergency_approval", data);
            if (responseApprove.status == 200) {
              this.getData(true);
              this.$toast.success(`Orden aprobada con exito!`);
              this.reasonDialog = false;
              this.is_emergency_approval = false;
            } else {
              this.$toast.error(await this.readErrorMessage(responseApprove));
            }
        } catch (error) {
          this.$toast.error('Error: ' + error.message);
        }
    },
    closeReasonDialog() {
      this.reasonDialog = false;
      this.cancelReason = "";
      this.selectedAction = null;
    },
    sumPresupuesto(campo) {
      return (this.presupuesto || []).reduce(
        (total, item) => total + (parseFloat(item[campo]) || 0),
        0
      );
    },
    progress(budget) {
      const totalBudget = parseFloat(budget?.total_budget) || 0;
      const totalConsumed = parseFloat(budget?.total_consumed) || 0;

      let progres = {
        value: totalBudget == 0
          ? 0
          : Number((100 - (totalConsumed * 100) / totalBudget).toFixed(0)),
        color: "success",
      };

      // Un consumo mayor al presupuesto deja la barra en 0 en vez de negativa.
      if (progres.value < 0) {
        progres.value = 0;
      }
      if (progres.value < 25) {
        progres.color = "error";
      } else if (progres.value >= 25 && progres.value < 50) {
        progres.color = "warning";
      }

      return progres;
    },
    getCommentText(comments) {
      try {
        if (!comments) return "";

        // Check if it's already a JSON object
        if (typeof comments === "object") {
          // Handle empty array with empty object case: [{}]
          if (Array.isArray(comments) && comments.length > 0) {
            // Check if it's an empty object
            if (Object.keys(comments[0]).length === 0) {
              return ""; // Empty object, return nothing
            }
            // If it has nota property
            if (comments[0].nota) {
              return comments[0].nota;
            }
          }
          // For other object types, stringify but check if it's meaningful
          const stringified = JSON.stringify(comments);
          return stringified === "[{}]" || stringified === "{}" ? "" : stringified;
        }

        // If it's a string, try to parse it as JSON
        if (typeof comments === "string") {
          if (comments.trim() === "[{}]" || comments.trim() === "{}") {
            return ""; // Empty JSON string, return nothing
          }

          try {
            const parsedComments = JSON.parse(comments);

            // Handle empty array with empty object case after parsing
            if (Array.isArray(parsedComments) && parsedComments.length > 0) {
              // Check if it's an empty object
              if (Object.keys(parsedComments[0]).length === 0) {
                return ""; // Empty object, return nothing
              }
              // If it has nota property
              if (parsedComments[0].nota) {
                return parsedComments[0].nota;
              }
            }

            // If we've gotten here and it's a simple object
            if (Object.keys(parsedComments).length === 0) {
              return ""; // Empty object
            }

            return comments;
          } catch (e) {
            // If it's not valid JSON, return the string as is
            return comments;
          }
        }

        return "";
      } catch (error) {
        console.error("Error parsing comment:", error);
        return "";
      }
    },
    getInitials(name) {
      if (!name) return "";
      const parts = name.split(" ");
      let initials = "";
      for (let i = 0; i < Math.min(parts.length, 2); i++) {
        if (parts[i].length > 0 && parts[i] !== "") {
          initials += parts[i][0];
        }
      }
      return initials;
    },
    isStepApproved(approval) {
      if (!this.data_order || !this.data_order[0]) return false;
      const history = this.data_order[0].order_histories || [];
      const approvalUserId = approval.user_id || approval.USER_ID;

      // Un paso se considera aprobado si el usuario aparece en el historial
      // con un estado de orden que no sea 'Nuevo/Borrador' (1) o 'Pendiente/Aprobando' (2)
      // O si el last_status de la propia orden ya superó este nivel (si tuviéramos mapeo de niveles)
      return history.some(h =>
        (h.user_id === approvalUserId || h.use_fullname === approval.use_fullname) &&
        h.order_status_id > 2 &&
        h.order_status_id < 11
      ) || !!approval.last_status;
    },
    isCurrentApprover(approval) {
      const currentApproverId = this.data_order?.[0]?.orders_approval_user;
      const approvalUserId = approval.user_id || approval.USER_ID;
      return Number(currentApproverId) === Number(approvalUserId);
    },
    async goQuotation(item) {
      this.$router.push({
        name: "QuoteDetailView",
        params: {
          quotation_id: item.quotation_id,
          supplier_id: item.entity_id,
        },
      });
    },
    sendOrder() {
      let items_selected = [];
      let order_details = [];

      let data = {
        type: 2,
        order_id: this.data_order[0]?.order_id,
        request_id: this.data_order[0]?.request_id,
        quotation_id: this.data_order[0]?.quotation_id,
        business_unit_id: this.filters.business.value,
        department_id:
          this.filters.department_id != null ? this.filters.department_id.value : null,
        location_id: this.filters.location.value,
        created_by: this.$store.state.auth.user.user.user_id,
        entity_id: this.selectedEntity.entity_id,
        total_amount: this.total,
        currency_id: this.seleted_currencies,
        note: this.nota,
        invoice_supplier: this.invoice_supplier,
        order_details: order_details,
        invoice_details: items_selected,
        project: this.filters.project == null ? null : this.filters.project.id,
        warehouse: this.filters.warehouse_id,
        status:
          id == 1 ? null : `'${JSON.stringify([{ order_status_id: 2 }]).toString()}'`,
      };

      this.$emit("save-order", data);
    },

    async approve_emergency() {
        this.is_emergency_approval = true;
        this.dialogTitle = `Seguro que desea aprobar esta orden de emergencia?`;
        this.cancelReason = "";
        this.reasonDialog = true;
    },

    devolverOrden() {
      if (this.data_entry_order && this.data_entry_order.length > 0) {
        this.$toast.warning("No se puede devolver la orden porque tiene una recepción registrada. Debe cancelar la recepción primero.");
        return;
      }
      this.AprovedOrReject(12);
    },
    async AprovedOrReject(type) {
      console.log(type)
      // await this.notifyNextApprover();
      // return
      // For return (12) or cancel (11), show the reason dialog
      if (type === 11 || type === 12 || type === 14) {
        this.selectedAction = type==12?1:type;//si es devolver, envia 1 borrador
        this.dialogTitle = `Seguro que desea ${this.array_reason_titles.find((element) => element.id == type).text}?`;
        this.cancelReason = "";
        this.reasonDialog = true;
        return;
      }

      // For other actions (approve, etc.), proceed normally
      let status = null;
      if (type === 1) {
        status = this.data_order[0]?.last_status_id + 1;
      } else if (type === null) {
        status = 1;
      } else {
        status = type;
      }
      let data = {
        order_id: this.id_orders,
        user_id: this.$store.state.auth.user.user.user_id,
        order_status_id: status,
        metadata: { nota: null, amount: this.total },
      };
      console.log(data)
      const responseApprove = await this.api_Post("shopping/approve_or_reject", data);
      if (responseApprove.status == 200) {
        const approvedBy = data.user_id;
        const approvedStatusId = data.order_status_id;
        await this.getData(true);
        this.$toast.success("Aprobado!");
        await this.notifyNextApprover(approvedBy, approvedStatusId);
      } else if (responseApprove.status == 409) {
        // Presupuesto excedido: se refresca la pantalla para reflejar el bloqueo.
        this.$toast.error(await this.readErrorMessage(responseApprove));
        await this.getData(true);
      } else {
        this.$toast.error(await this.readErrorMessage(responseApprove));
      }
    },
    // api_Post devuelve el Response crudo: el mensaje real viene en el cuerpo.
    async readErrorMessage(response, fallback = "Ocurrió un error al procesar la orden") {
      try {
        const body = await response.json();
        return body?.message || body?.error || fallback;
      } catch (e) {
        return fallback;
      }
    },
    async notifyNextApprover(approvedBy, approvedStatusId, isResend = false) {
      const nextApproverId = this.data_order?.[0]?.orders_approval_user;
      const orderId = this.data_order?.[0]?.order_id;
      if (!nextApproverId || !orderId) return;
      try {
        const response = await this.api_Post("shopping/send_approval_email", {
          order_id: orderId,
          user_id: nextApproverId,
          approved_by: approvedBy,
          approved_status_id: approvedStatusId,
        });
        if (response.status == 200) {
          const body = await response.json();
          if (!body?.skipped) {
            const sentTo = body?.sent_to;
            const accion = isResend ? "Notificación reenviada" : "Notificación enviada";
            // MAIL_DRY_RUN en el backend: el correo no salió, se avisa para no
            // confundir durante las pruebas.
            if (body?.dry_run) {
              this.$toast.warning(
                `Modo prueba: el correo NO se envió (habría ido a ${sentTo || "el siguiente aprobador"})`
              );
              return true;
            }
            this.$toast.success(
              sentTo
                ? `${accion} al siguiente aprobador (${sentTo})`
                : `${accion} al siguiente aprobador`
            );
            return true;
          } else if (isResend) {
            this.$toast.warning("El aprobador tiene las notificaciones automáticas desactivadas");
          }
        } else if (isResend) {
          this.$toast.error("No se pudo reenviar la notificación al aprobador");
        }
        return false;
      } catch (e) {
        // No bloqueamos el flujo de aprobación si falla el envío del correo.
        console.error("Error al enviar correo al aprobador:", e);
        if (isResend) this.$toast.error("No se pudo reenviar la notificación al aprobador");
        return false;
      }
    },
    async resendApprovalEmail() {
      this.resendingApprovalEmail = true;
      try {
        const sent = await this.notifyNextApprover(null, null, true);
        this.approvalEmailResent = sent;
      } finally {
        this.resendingApprovalEmail = false;
      }
    },
    dateFormated(date) {
      //const dates = moment(date).format('DD/MM/YYYY h:mm a');
      return momentTimezone(date).tz("America/Santo_Domingo").format("DD/MM/YYYY h:mm a");
    },
    loadLogo() {
      if (this.data_order[0]?.business_units_image_storage != null) {
        this.locationImage = this.get_storage(
          this.data_order[0]?.business_units_image_storage
        );
      } else {
        this.locationImage = null;
      }
    },
    async delete_adjunto() {
      this.clearAttachedPreview();
      this.attachedKey = "";
      this.attachedName = "";
      this.attachedPreviewable = false;
      if (this.data_order && this.data_order[0]) {
        this.$set(this.data_order[0], "data_json", null);
      }

      //  if (this.data_order[0]?.data_json.collectionId !=undefined && this.data_order[0]?.data_json.collectionId !=null) {
      //     await this.delete_file_storage(this.data_order[0]?.data_json.collectionName,this.data_order[0]?.data_json.id);
      //   }
    },
    async getData(type) {
      this.data_order = [];
      this.approvalEmailResent = false;
      this.loading = true;
      let responseRequest = { status: 200 };

      this.itbis = await this.api_Get("accounting/taxes");
      if (type) {
        this.id_orders = this.$route.params.id;
        responseRequest = await this.api_Post("shopping/search_order_id", {
          number: this.id_orders,
        });
        this.data_order = await responseRequest.json();
      } else {
        this.showOrder(this.next_order_data.order_id, true);
        this.id_orders = this.next_order_data.order_id;
        this.data_order.push(this.next_order_data);
      }

      if (responseRequest.status == 200) {
        const orderLocationId = this.data_order[0]?.location_id;
        const userLocations = this.$store.state.auth.locations || [];
        if (
          orderLocationId != null &&
          !userLocations.some(
            (loc) => loc.id === orderLocationId || loc.value === orderLocationId
          )
        ) {
          this.loading = false;
          this.$router.replace({ name: "NoAcces" });
          return;
        }
        this.data_order.forEach((element) => {
          element.amount = element.price;
        });
        if (this.data_order[0]?.last_status_id >= 13) {
          //obtiene las recepciones
          const responseEntry = await this.api_Post("shopping/search_entry_order", {
            order_id: this.data_order[0]?.order_id,
            filters: "",
          });
          if (responseEntry.status == 200) {
            this.data_entry_order = await responseEntry.json();
          }
          //obtiene las facturas
          let resultInvoices = await this.api_Post("income/invoice_sales_list", {
            filters: ` WHERE INVOICES.ORDER_ID=${this.data_order[0]?.order_id}`,
          });
          this.invoices = await resultInvoices.json();
        }
        // let resultLevel = await this.api_Post("shopping/order_level", {
        //   business_unit_id: this.data_order[0]?.business_unit_id,
        //   location_id: this.data_order[0]?.location_id,
        // });
        // let level = await resultLevel.json();
        // this.level = level;
        this.loadLogo();
        if (this.data_order[0]?.data_json != null) {
          this.viewAddtached(this.data_order[0]?.data_json);
        }
      } else {
        this.$toast.error("error al cargar!");
      }

      // El backend resuelve el "excedido" para que la pantalla y la validación
      // de aprobación usen exactamente la misma regla.
      this.presupuesto = [];
      this.presupuesto_excedido = false;
      this.presupuesto_mensaje = "";
      const responsePresupuesto = await this.api_Post("shopping/get_presupuesto", {
        order_id: this.id_orders,
      });
      if (responsePresupuesto.status == 200) {
        const dataPresupuesto = await responsePresupuesto.json();
        this.presupuesto = dataPresupuesto?.rows || [];
        this.presupuesto_excedido = dataPresupuesto?.exceeded === true;
        this.presupuesto_mensaje = dataPresupuesto?.message || "";
      } else {
        this.$toast.error("error al cargar el presupueto!");
      }
      // const responseLevel = await this.api_Post("shopping/order_level", {
      //   business_unit_id: this.data_order[0]?.business_unit_id,
      //   location_id: this.data_order[0]?.location_id,
      // });
      // if (responseLevel.status == 200) {
      //   this.reponse_level = await responseLevel.json();
      // } else {
      //   this.$toast.error("error al cargar la factura!");
      // }
      this.get_user_orders();
      this.loading = false;
    },
    getDate(item) {
      return moment(item).format("DD/MM/YYYY");
    },
    async editOrder(item) {
      this.loadingSave = true;
      // Check if it's a reception register and validate warehouse_id
      if (item.type === 3) {
        const itemsWithoutWarehouse = item.order_details?.filter(
          (detail) => !detail.warehouse_id
        );

        if (itemsWithoutWarehouse?.length > 0) {
          const itemIds = itemsWithoutWarehouse.map((d) => d.item_id).join(", ");
          this.$toast.error(`Los siguientes ítems no tienen almacén asignado: ${itemIds}`);
          this.loadingSave = false;
          return;
        }
      }
      try {
        const route =
          item.type !== 3 ? "shopping/order_register" : "shopping/reception_register";
        const responseRequest = await this.api_Post(route, item);

        if (responseRequest.status === 200) {
          // const data = await responseRequest.json();
          this.$toast.success("Guardado");
          this.getData(true);
          this.dialog = false;
          this.loadingSave = false;
        } else {
          const result = await responseRequest.json();
          const error = result.message;
          this.$toast.warning(error.toString());
          this.loadingSave = false;
        }
      } catch (error) {
        console.error(error.message);
      }
    },
    // Tipos que el navegador puede mostrar dentro del iframe. Cualquier otro
    // tipo (word, excel, zip, sin extension, etc.) se descargaria solo al
    // asignarlo al iframe, por eso solo se previsualizan estos.
    attachedMimeByExt(name) {
      const parts = String(name || '').split('.');
      const ext = parts.length > 1 ? parts.pop().toLowerCase() : '';
      const mimes = {
        pdf: 'application/pdf',
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        webp: 'image/webp',
        bmp: 'image/bmp',
      };
      return mimes[ext] || null;
    },
    clearAttachedPreview() {
      if (this.selectedAttached && this.selectedAttached.startsWith('blob:')) {
        URL.revokeObjectURL(this.selectedAttached);
      }
      this.selectedAttached = '';
    },
    async viewAddtached(item) {
      this.loadingAttachment = true;
      try {
        this.clearAttachedPreview();
        if (item && item.key) {
          this.attachedKey = item.key;
          this.attachedName = item.name || item.key.split('/').pop();
          const mime = this.attachedMimeByExt(this.attachedName) || this.attachedMimeByExt(item.key);
          this.attachedPreviewable = mime != null;
          if (!this.attachedPreviewable) {
            // No se previsualiza: se ofrece descarga manual en lugar de
            // dispararla sola al cargar la orden.
            return;
          }
          const resp = await fetch(this.spaces_file_url(item.key));
          const blob = await resp.blob();
          const safeBlob =
            blob.type && blob.type !== 'application/octet-stream'
              ? blob
              : new Blob([blob], { type: mime });
          this.selectedAttached = URL.createObjectURL(safeBlob);
        } else {
          this.attachedKey = '';
          this.attachedName = '';
          this.attachedPreviewable = false;
        }
      } catch (err) {
        console.error('[viewAddtached] error:', err);
        this.clearAttachedPreview();
        // Si no se pudo cargar la vista previa, se muestra la tarjeta de descarga.
        this.attachedPreviewable = false;
      } finally {
        this.loadingAttachment = false;
      }
    },
    async downloadAttached() {
      if (!this.attachedKey) return;
      this.downloadingAttachment = true;
      try {
        const resp = await fetch(this.spaces_file_url(this.attachedKey));
        const blob = await resp.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = this.attachedName || 'adjunto';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
      } catch (err) {
        console.error('[downloadAttached] error:', err);
        this.$toast.error('No se pudo descargar el adjunto');
      }
      this.downloadingAttachment = false;
    },
    async onFileChange() {
      try {
        const fileInput = document.getElementById("fileInput");
        const file = fileInput.files[0];
        if (!file) return;

        const result = await this.upload_to_spaces(file, "orders_atached");

        const responseRequest = await this.api_Post("shopping/order_json", {
          order_id: this.data_order[0]?.order_id,
          data_json: { url: result.url, key: result.key, name: file.name },
        });
        if (responseRequest.status == 200) {
          this.$toast.success("Guardado!");
          this.getData(true);
        } else {
          this.$toast.error("error al cargar!");
        }
      } catch (e) {
        this.$toast.error("error " + e.message);
      }
    },
    takeImage() {
      //this.fileInput.click();
      document.getElementById("fileInput").click();

      //this.this.dialogImage = true;
    },

    async downloadInvoice() {
      if (this.data_order[0]?.last_status_id == 15) {
        let data = {
          order_id: this.id_orders,
          user_id: this.$store.state.auth.user.user.user_id,
          order_status_id: 13,
          metadata: null,
        };

        const responseApprove = await this.api_Post("shopping/approve_or_reject", data);
        if (responseApprove.status != 200) {
          this.$toast.error("error al generar la impresion!");
        }
      }
      this.$router.push({
        name: "DownloadOrder",
        params: { id: this.data_order[0]?.order_id },
      });
    },
    selectItem(item) {
      this.selectedEntity = item;
      this.dialogSearch = false;
    },
    selectPayment(item) {
      this.selectedPayments = item;
      this.dialogPayments = false;
    },
    deleteItem(item) {
      let editIndex = this.selectedPayments.indexOf(item);

      this.selectedPayments.splice(editIndex, 1);
    },
    async setAccounts(accounts) {
      let items_accounting = [];
      for (let item of this.data_order[0]?.order_details) {
        items_accounting.push({
          item_id: item.item_id,
          item_name: item.item_name,
          price: item.price,
          tax_id: item.tax_id,
          tax_value: item.tax_value,
          discount: item.discount,
          request_id: item.request_id,
          quantity: item.quantity,
          department_id: item.department_id,
          warehouse_id: item.warehouse_id,
          order_chart_of_accounts: accounts.filter((element) => element.item_id == item.item_id && element.entry_id == item.request_id),
        });
      }
      const order_note = this.data_order[0]?.note == undefined ? this.data_order[0]?.comments : this.data_order[0]?.note;
      const payload = {
        type: this.data_order[0],
        order_id: this.data_order[0]?.order_id,
        quotation_id: this.data_order[0]?.quotation_id,
        business_unit_id: this.data_order[0]?.business_unit_id,
        location_id: this.data_order[0]?.location_id,
        created_by: this.$store.state.auth.user.user.user_id,
        entity_id: this.data_order[0]?.entity_id,
        total_amount: this.data_order[0]?.total_amount,
        currency_id: this.data_order[0]?.currency_id,
        note: order_note,
        invoice_supplier: this.data_order[0]?.invoice_supplier,
        invoice_details: items_accounting,
        warehouse: this.data_order[0]?.warehouse_id,
        status: this.data_order[0]?.order_histories,
        credit_days_id: this.data_order[0]?.credit_days_id,
      };
      try {
        this.loadingSave = true;
        const responseRequest = await this.api_Post("shopping/update_order_accounting", payload);

        if (responseRequest.status === 200) {
          this.$toast.success("Guardado");
          this.loadingSave = false;
        } else {
          const data = await responseRequest.json();
          this.$toast.error(data.message);
          this.loadingSave = false;
        }
      } catch (error) {
        console.error(error.message);
      }
    },
    delente_entry(entry) {
      this.entry_to_delete = entry;
      this.dialog_confirm = true;
    },
    async confirm_delete_entry(response) {
      if (!response) {
        this.dialog_confirm = false;
        return
      }
      const index = this.data_entry_order.indexOf(this.entry_to_delete);
      try {
        this.loading_entry_delete = true;
        const responseRequest = await this.api_Post("shopping/cancel_order_entry", { entry_id: this.entry_to_delete.entry_id });
        if (responseRequest.status === 200) {
          this.$toast.success("Entrada eliminada con exito!");
          this.loading_entry_delete = false;
          this.data_entry_order.splice(index, 1);
          this.dialog_confirm = false;
        } else {
          const result = await responseRequest.json();
          const error = result.message;
          this.$toast.warning(error.toString());
        }
      } catch (error) {
        console.error(error.message);
      }
      this.loading_entry_delete = false;
    },
    next_order() {
      this.next_order_data = this.others_orders[0];
      this.getData(false);
    },
    async reopen_order() {
      if (this.$store.state.auth.globalFeatures.includes('SHOP-117') == false) {
        this.$toast.error("No tiene permiso para realizar esta accion!");
        return;
      }

      let data = {
        order_id: this.id_orders,
        user_id: this.$store.state.auth.user.user.user_id,
        order_status_id: 13,//pendiente de recepcion
        metadata: { nota: this.cancelReason },
      };

      const responseApprove = await this.api_Post("shopping/approve_or_reject", data);
      if (responseApprove.status == 200) {
        this.getData(true);
        this.$toast.success(`Orden reabierta con exito!`);
        this.reasonDialog = false;
      } else {
        this.$toast.error('Error: ' + responseApprove.message);
      }
    },
  },
};
</script>

<style scoped>
nota-destacada {
  background-color: #fff3e0;
  border-left: 4px solid #ff9800;
  margin: 8px 0;
  padding: 12px 16px !important;
  border-radius: 0 8px 8px 0;
  font-size: 14px;
  color: #e65100;
}

/* Mejoras sutiles de estilo */
.v-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.v-timeline-item .v-card {
  border-radius: 8px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.v-timeline-item .v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.v-card-title {
  border-radius: 8px 8px 0 0;
  font-weight: 500;
}

.v-card-text {
  font-size: 14px;
}

.v-timeline-item__dot {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

/* Responsive */
@media (max-width: 768px) {
  .v-timeline-item__opposite {
    display: none !important;
  }
}

.etiqueta_invoice {
  width: 180px;
  height: 50px;
  background-color: rgb(18, 116, 18);
  color: white;
  font-size: 20px;
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;

  transform: rotate(-45deg);
}

.folded_corner {
  position: relative;
  width: 100%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: linear-gradient(to left bottom, transparent 50%, rgba(0, 0, 0, 0.05) 0) no-repeat 100% 0 / 2em 2em,
    linear-gradient(-135deg, transparent 1.5em, white 0);
}

.folded_corner::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 40px 40px 0;
  border-color: transparent transparent rgba(0, 0, 0, 0.05) transparent;
  pointer-events: none;
}

/* Expert UI Improvements */
.custom-table {
  background-color: transparent !important;
}

.custom-table th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 11px !important;
  font-weight: 700 !important;
  color: #5c6bc0 !important;
}

.signature-box {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.signature-line {
  width: 100%;
  height: 1px;
  background: #bdbdbd;
  margin-bottom: 8px;
  margin-top: 10px;
}

.signature-image {
  mix-blend-mode: multiply;
  opacity: 0.9;
  filter: grayscale(0.2);
}

.signature-placeholder {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Status Stamp Styles */
.status-stamp {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-30deg);
  font-size: 80px;
  font-weight: 900;
  opacity: 0.1;
  pointer-events: none;
  z-index: 0;
  border: 15px solid;
  padding: 10px 40px;
  border-radius: 20px;
  white-space: nowrap;
}

.status-stamp.closed {
  color: #2e7d32;
  border-color: #2e7d32;
}

.status-stamp.cancelled {
  color: #c62828;
  border-color: #c62828;
}

.position-relative {
  position: relative;
}

.overflow-hidden {
  overflow: hidden;
}

/* Approval Path Styles */
.approval-path-card {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05) !important;
}

.approval-path {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 15px 5px;
}

.approval-step {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.step-container {
  display: flex;
  align-items: center;
  background: white;
  padding: 12px 20px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  min-width: 320px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.step-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 25px rgba(25, 118, 210, 0.1);
  border-color: #1976d2;
}

.step-avatar {
  background: linear-gradient(135deg, #1976d2, #64b5f6) !important;
  box-shadow: 0 4px 10px rgba(25, 118, 210, 0.3);
}

.step-info {
  margin-left: 15px;
}

.step-check-badge {
  position: absolute;
  top: 4px;
  right: 60px;
  background: #2e7d32;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow: 0 4px 10px rgba(46, 125, 50, 0.4);
  border: 2px solid white;
  animation: badge-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes badge-in {
  from {
    transform: scale(0) rotate(-45deg);
    opacity: 0;
  }
  to {
    transform: scale(1) rotate(0);
    opacity: 1;
  }
}

.step-connector {
  display: flex;
  align-items: center;
  color: #e0e0e0;
}

.limit-chip {
  font-size: 11px;
  padding: 2px 10px;
  border-radius: 20px;
  margin-top: 6px;
  display: inline-block;
  font-weight: 600;
}

.limit-low {
  background: #fff8e1;
  color: #ffa000;
}

.limit-high {
  background: #e8f5e9;
  color: #2e7d32;
}

/* Custom Scrollbar */
.custom-scrollbar::-webkit-scrollbar {
  height: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #9e9e9e;
}
</style>
